import { ActionContext, Store } from 'vuex'
import { sendConsentLogs } from '@/services/cookie-consent.service'
import Cookies from 'js-cookie'
const COOKIE_CONSENT_LEVEL = 'consentLevelCookie'

export const NAMESPACE = 'cookie-consent'

export enum Properties {
  MainModalOpen = 'mainModalOpen',
  PolicyModalOpen = 'policyModalOpen',
  ConsentModalOpen = 'consentModalOpen',
  LevelSelected = 'levelSelected',

  CloseMainModal = 'closeMainModal',
  OpenPolicyModal = 'openPolicyModal',
  ClosePolicyModal = 'closePolicyModal',
  OpenConsentModal = 'openConsentModal',

  UpdateLevelSelected = 'updateLevelSelected',
  PreloadCookies = 'preloadCookies'
}

const namespace = (fragment: string) => `${NAMESPACE}/${fragment}`

interface State {
  [Properties.MainModalOpen]: boolean;
  [Properties.PolicyModalOpen]: boolean;
  [Properties.ConsentModalOpen]: boolean;
  [Properties.LevelSelected]: number;
}

export type VuexActionContext = ActionContext<State, {}>

export const getMainModalOpen = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.MainModalOpen)]
export const getPolicyModalOpen = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.PolicyModalOpen)]
export const getConsentModalOpen = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.ConsentModalOpen)]
export const getLevelSelected = (store: Store<VuexActionContext>): number => store.getters[namespace(Properties.LevelSelected)]

export const openPolicyModal = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.OpenPolicyModal))
export const closePolicyModal = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.ClosePolicyModal))
export const openConsentModal = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.OpenConsentModal))
export const closeMainModal = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.CloseMainModal))

export const updateLevelSelected = (store: Store<VuexActionContext>, payload: number): Promise<void> => store.dispatch(namespace(Properties.UpdateLevelSelected), payload)
export const preloadCookies = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.PreloadCookies))

const CookieConsentStore = {
  namespaced: true,
  state: {
    [Properties.MainModalOpen]: false,
    [Properties.PolicyModalOpen]: false,
    [Properties.ConsentModalOpen]: false,
    [Properties.LevelSelected]: 1
  },
  getters: {
    [Properties.MainModalOpen]: (state: State) => state[Properties.MainModalOpen],
    [Properties.PolicyModalOpen]: (state: State) => state[Properties.PolicyModalOpen],
    [Properties.ConsentModalOpen]: (state: State) => state[Properties.ConsentModalOpen],
    [Properties.LevelSelected]: (state: State) => state[Properties.LevelSelected]
  },
  mutations: {
    [Properties.PolicyModalOpen]: (state: State, value: boolean) => {
      state[Properties.PolicyModalOpen] = value
    },
    [Properties.MainModalOpen]: (state: State, value: boolean) => {
      state[Properties.MainModalOpen] = value
    },
    [Properties.ConsentModalOpen]: (state: State, value: boolean) => {
      state[Properties.ConsentModalOpen] = value
    },
    [Properties.LevelSelected]: (state: State, value: number) => {
      state[Properties.LevelSelected] = value
    }
  },
  actions: {
    [Properties.OpenPolicyModal]: ({ commit }: ActionContext<State, {}>): void => {

      commit(Properties.MainModalOpen, false)
      commit(Properties.ConsentModalOpen, false)
      commit(Properties.PolicyModalOpen, true)
    },
    [Properties.ClosePolicyModal]: ({ commit }: ActionContext<State, {}>): void => {
      commit(Properties.PolicyModalOpen, false)
      commit(Properties.ConsentModalOpen, false)
      commit(Properties.MainModalOpen, true)
    },
    [Properties.OpenConsentModal]: ({ commit }: ActionContext<State, {}>): void => {

      commit(Properties.PolicyModalOpen, false)
      commit(Properties.MainModalOpen, false)
      commit(Properties.ConsentModalOpen, true)
    },
    [Properties.CloseMainModal]: ({ commit }: ActionContext<State, {}>): void => {

      commit(Properties.MainModalOpen, false)
      commit(Properties.ConsentModalOpen, false)
      commit(Properties.PolicyModalOpen, false)
    },
    [Properties.UpdateLevelSelected]: async ({ commit }: ActionContext<State, {}>, payload: number): Promise<void> => {
      commit(Properties.LevelSelected, payload)
      Cookies.set(COOKIE_CONSENT_LEVEL, payload.toString(), { expires: 365 })
      await sendConsentLogs(payload, window.location.hostname)
    },
    [Properties.PreloadCookies]: async ({ commit }: ActionContext<State, {}>): Promise<void> => {
      const cookieConsentLevel = Cookies.get(COOKIE_CONSENT_LEVEL)
      if (cookieConsentLevel) {
        commit(Properties.LevelSelected, Number(cookieConsentLevel))
      } else {
        commit(Properties.LevelSelected, 1)
        commit(Properties.MainModalOpen, true)
      }
    }
  }
}

export default CookieConsentStore
